export default __webpack_public_path__ + "static/media/right-arrow.4a613741.svg";